import React, { act, useEffect, useState } from "react";

// Modules
import { NestedMenuItem } from "mui-nested-menu";

// App
import { sitaEnabled, referenceEnabled } from "../../config";
import { decodeHtmlEntities } from "../../utils/helpers";
import { getOnlineNode } from "../../core/getNode";
import { patchNode } from "../../core/postNode";
import PostShare from "./postShare";
import { usePostContext } from "../../contexts/postContext";
import AlertModal from "../alertModal";

// UI components
import { Container, Row, Col } from "react-bootstrap";
import {
  Alert,
  CircularProgress,
  Box,
  Stack,
  Button,
  Dialog,
  DialogContent,
  Stepper,
  Step,
  StepButton,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Autocomplete,
  Typography,
  OutlinedInput,
  Tooltip,
} from "@mui/material";
import { ChevronRight, InfoOutlined } from "@mui/icons-material";
import DialogPaper from "../dialogPaper";

let steps = [];

if (sitaEnabled) {
  steps = ["Access", "Category, SITA & Language", "Ready"];
}

if (referenceEnabled) {
  steps = ["Access", "Category, Reference & Language", "Ready"];
}

const cleanTaxonomies = (taxonomies) => {
  let tax = [];

  taxonomies.forEach((taxonomy) => {
    if (taxonomy.value !== 0) {
      tax.push(taxonomy);
    }
  });
  return tax;
};

export default function PostPublishing(props) {
  const {
    activeGridItem,
    setActiveGridItem,
    showPublish,
    setShowPublish,
    showUnpublish,
    setShowUnpublish,
    setActiveGridItemActions,
    setSharePostItem,
    setShareModalOpen,
    setHideShare,
    entityType,
  } = usePostContext();

  const [isLoading, setLoading] = useState(true);
  const [activeStep, setActiveStep] = useState(0);

  // categories
  const categories = cleanTaxonomies(props.categories);
  const languages = cleanTaxonomies(props.languages);
  const sitas = cleanTaxonomies(props.sitas);
  const references = cleanTaxonomies(props.references);
  const [open, setOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(
    activeGridItem?.category?.tid ? activeGridItem?.category?.tid : "0",
  );
  const [selectedLanguage, setSelectedLanguage] = useState(
    parseInt(
      activeGridItem?.language?.tid ? activeGridItem?.language?.tid : null,
    ),
  );
  const [selectedSita, setSelectedSita] = useState(null);
  const [selectedReference, setSelectedReference] = useState(null);

  const [permissionsComplete, setPermissionsComplete] = useState(false);
  const [categoryComplete, setCategoryComplete] = useState(
    selectedCategory === 0 ? false : true,
  );
  const [languageComplete, setLanguageComplete] = useState(
    selectedLanguage === 0 ? false : true,
  );
  const [sitaComplete, setSitaComplete] = useState(false);
  const [referenceComplete, setReferenceComplete] = useState(false);
  const [completed, setCompleted] = useState(true);

  // permissions
  // eslint-disable-next-line
  const [postPermissions, setPostPermissions] = useState({});
  const [customPermsError, setCustomPermsError] = useState(false);
  const [keepPrivate, setPrivate] = useState(false);
  const [makePublic, setPublic] = useState(false);
  const [advancedPermissions, setAdvancedPermissions] = useState(false);

  // permissions
  useEffect(() => {
    if (activeGridItem) {
      if (activeGridItem?.category_ids) {
        setSelectedCategory(activeGridItem.category_ids);
      }
      if (activeGridItem?.reference === null) {
        setSelectedReference(
          references.find((item) => parseInt(item.tid) === 0),
        );
      } else {
        setSelectedReference(
          references.find(
            (item) => parseInt(item.tid) === activeGridItem.reference?.tid,
          ),
        );
      }
      if (activeGridItem?.language) {
        setSelectedLanguage(parseInt(activeGridItem.language?.tid));
      }
      getOnlineNode(
        `api/v3/${entityType}/permissions/${activeGridItem.id}?_format=json`,
      )
        .then((response) => {
          setPostPermissions(response.data);
          checkState(false, response.data);
        })
        .catch((_error) => {
          const emptyData = {
            access_collection: [],
            access_collection_list: [],
            role_list: [],
            roles: {},
            users: [],
          };

          setCustomPermsError(true);
          setPostPermissions(emptyData);
          checkState(false, emptyData);
        });
    } else {
      setActiveStep(0);
      setActiveGridItemActions({});

      setSelectedCategory("0");
      setSelectedLanguage(null);
      setSelectedSita(null);
      setSelectedReference(null);

      setPermissionsComplete(false);
      setCategoryComplete(false);
      setLanguageComplete(false);
      setSitaComplete(false);
      setReferenceComplete(false);
      setCompleted(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeGridItem]);

  // // selected sita
  // useEffect(() => {
  //   if (sitaEnabled) {
  //     let selected;

  //     if (activeGridItem?.sita?.tid) {
  //       selected = sitas.find(
  //         (item) => parseInt(item.tid) === parseInt(activeGridItem?.sita?.tid),
  //       );
  //     } else {
  //       selected = sitas.find((item) => parseInt(item.tid) === 0);
  //     }
  //     setSelectedSita(selected);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // // selected reference
  // useEffect(() => {
  //   if (referenceEnabled) {
  //     let selected;

  //     if (activeGridItem?.reference?.tid) {
  //       selected = references.find(
  //         (item) =>
  //           parseInt(item.tid) === parseInt(activeGridItem?.reference?.tid),
  //       );
  //     } else {
  //       selected = references.find((item) => parseInt(item.tid) === 0);
  //     }
  //     setSelectedReference(selected);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  useEffect(() => {}, [
    selectedCategory,
    selectedLanguage,
    selectedSita,
    selectedReference,
  ]);

  // Step completion checker
  useEffect(() => {
    if (permissionsComplete && categoryComplete && languageComplete) {
      if (sitaEnabled) {
        if (sitaComplete) {
          setCompleted(true);
        }
      }

      if (referenceEnabled) {
        if (referenceComplete) {
          setCompleted(true);
        }
      }
    } else {
      if (completed) {
        setCompleted(false);
      }
    }
  }, [
    permissionsComplete,
    categoryComplete,
    languageComplete,
    sitaComplete,
    referenceComplete,
    completed,
  ]);

  // permissions
  useEffect(() => {
    if (!keepPrivate && !makePublic && !advancedPermissions) {
      setPermissionsComplete(false);
    } else {
      if (!advancedPermissions) {
        setPermissionsComplete(true);
      } else {
        // check permissions here
      }
    }
  }, [keepPrivate, makePublic, advancedPermissions]);

  // categories
  useEffect(() => {
    if (!selectedCategory || parseInt(selectedCategory) === 0) {
      setCategoryComplete(false);
    } else {
      setCategoryComplete(true);
    }
  }, [selectedCategory]);

  // language
  useEffect(() => {
    if (!selectedLanguage || parseInt(selectedLanguage) === 0) {
      setLanguageComplete(false);
    } else {
      setLanguageComplete(true);
    }
  }, [selectedLanguage]);

  // sita
  useEffect(() => {
    if (sitaEnabled) {
      if (!selectedSita || parseInt(selectedSita) === 0) {
        setSitaComplete(false);
      } else {
        setSitaComplete(true);
      }
    }
  }, [selectedSita]);

  // reference
  useEffect(() => {
    if (referenceEnabled) {
      if (!selectedReference || parseInt(selectedReference) === 0) {
        setReferenceComplete(false);
      } else {
        setReferenceComplete(true);
      }
    }
  }, [selectedReference]);

  const checkState = (shouldUpdateSteps, perms) => {
    let step = 0;
    let permsComplete = false;
    let catComplete = false;
    let langComplete = false;

    if (Object.keys(perms?.roles)?.length > 0 || perms?.users?.length > 0) {
      if (Object.keys(perms?.roles)?.length > 1) {
        setPrivate(false);
        setPublic(false);
        setAdvancedPermissions(true);
      } else {
        if (perms.roles["rhg_viewer"] || perms.roles["standard_viewer"]) {
          setPrivate(false);
          setPublic(true);
          setAdvancedPermissions(false);
        } else {
          setPrivate(false);
          setPublic(false);
          setAdvancedPermissions(true);
        }
      }

      step = step + 1;
      permsComplete = true;
    } else {
      setPrivate(true);
      setPublic(false);
      setAdvancedPermissions(false);

      step = step + 1;
      permsComplete = true;
    }

    if (activeGridItem.category_ids && activeGridItem.category_ids !== "0") {
      catComplete = true;
    }

    if (activeGridItem.language?.tid) {
      langComplete = true;
    }

    setSitaComplete(true);
    setPermissionsComplete(permsComplete);
    setCategoryComplete(catComplete);
    setLanguageComplete(langComplete);

    if (permsComplete) {
      step = 1;

      if (permsComplete && catComplete && langComplete) {
        step = 2;
      }
    } else {
      step = 0;
    }

    if (shouldUpdateSteps) {
      setActiveStep(step);
    }

    setLoading(false);
  };

  const hideModal = () => {
    setAdvancedPermissions(false);
    setShowPublish(false);
    setShowUnpublish(false);
    setActiveGridItem(null);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleCategorySelection = (tid) => {
    setSelectedCategory(tid);
    setOpen(false);
  };

  const allCategoryValues = React.useMemo(() => {
    // only include real taxonomy IDs, skip 0 because "All Categories" is added manually
    return categories.map((c) => c.value);
  }, [categories]);

  const menuProps = {
    anchorOrigin: {
      vertical: "top",
      horizontal: "right",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left",
    },
    PaperProps: { style: { pointerEvents: "auto" } },
  };

  const onPublish = () => {
    let params = {
      category: selectedCategory,
      sita: selectedSita?.tid ? parseInt(selectedSita?.tid) : null,
      reference: selectedReference?.tid
        ? parseInt(selectedReference?.tid)
        : null,
      language: selectedLanguage,
    };

    if (makePublic) {
      params.permissions = 1;
    }

    if (keepPrivate) {
      params.permissions = 0;
    }

    // publishPost();
    updatePost()
      .then((response) => {
        publishPost();
      })
      .catch((error) => {
        console.error("Error updating post:", error);
      });
    hideModal();
  };

  const updatePost = () => {
    const path = `api/v3/${entityType}/${activeGridItem.id}`;
    const data = {
      field_category: [selectedCategory],
      sita: selectedSita?.tid ? parseInt(selectedSita?.tid) : null,
      reference: selectedReference?.tid
        ? parseInt(selectedReference?.tid)
        : null,
      language: selectedLanguage,
    };
    return patchNode(path, data, props.user.csrf_token);
  };

  const publishPost = () => {
    const publishPath = `${props.publishPath}/publish/${activeGridItem.id}`;

    getOnlineNode(publishPath, { timeout: 0 })
      .then((response) => {
        props.getContent();
      })
      .catch((error) => {
        console.log("publish error", error);
      });
  };

  const unpublishPost = () => {
    const unpublishPath = `api/v3/${entityType}/unpublish/${activeGridItem.id}`;

    getOnlineNode(unpublishPath, { timeout: 0 })
      .then((response) => {
        hideModal();
        props.getContent();
      })
      .catch((error) => {
        console.log("unpublish error", error);
      });
  };

  const renderMenuItems = (parentId = null) => {
    const items = categories.filter(
      (item) => item.parent_target_id === parentId,
    );

    return items.map((item) => {
      const children = categories.filter(
        (child) => child.parent_target_id === item.value,
      );

      if (children.length > 0) {
        if (!item.has_create_permission) {
          return null;
        }

        return (
          <NestedMenuItem
            key={`cat-${item.value}`}
            rightIcon={<ChevronRight />}
            leftIcon={null}
            parentMenuOpen={open}
            label={decodeHtmlEntities(item.label)}
            MenuProps={menuProps}
            className="settings-nested"
            onClick={() => handleCategorySelection(item.value)}
          >
            {renderMenuItems(item.value)}
          </NestedMenuItem>
        );
      }

      if (!item.has_create_permission) {
        return null;
      }

      return (
        <MenuItem
          key={`cat-${item.value}`}
          value={item.value}
          sx={{
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-selected": {
              backgroundColor: "primary.light",
            },
          }}
          onClick={() => handleCategorySelection(item.value)}
        >
          {decodeHtmlEntities(item.label)}
        </MenuItem>
      );
    });
  };

  return (
    <>
      {showPublish && activeGridItem && (
        <Dialog
          open={showPublish}
          onClose={() => hideModal}
          className="ps-modal share-modal"
          maxWidth="lg"
          fullWidth={true}
          PaperComponent={DialogPaper}
        >
          <Box className="ps-modal-title dialog-draggable-handle">
            <Container fluid>
              <Row className="align-items-center">
                <Col xs={12} sm={6}>
                  <Typography variant="h3" owner="admin" color="adminText.dark">
                    Publish {entityType} (ID: {activeGridItem.id})
                  </Typography>
                </Col>
                <Col xs={12} sm={6}>
                  <Stack
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    spacing={1}
                  >
                    <>
                      <Button
                        variant="outlined"
                        owner="admin"
                        dialogbtn="true"
                        dialogvariant="cancel"
                        onClick={() => {
                          hideModal();
                        }}
                      >
                        <Typography
                          variant="button"
                          owner="admin"
                          className="lh"
                        >
                          Cancel
                        </Typography>
                      </Button>
                    </>
                  </Stack>
                </Col>
              </Row>
            </Container>
          </Box>

          <DialogContent>
            <Box className="ps-modal-content">
              <Container fluid>
                {isLoading ? (
                  <Row>
                    <Col className="d-flex justify-content-center">
                      <CircularProgress size={20} />
                    </Col>
                  </Row>
                ) : (
                  <>
                    <Row className="mb-5 mt-3">
                      <Col>
                        <Stepper
                          nonLinear={completed ? true : false}
                          activeStep={activeStep}
                        >
                          {steps.map((label, index) => {
                            let isComplete = false;

                            if (index === 0) {
                              isComplete = permissionsComplete;
                            }

                            if (index === 1) {
                              isComplete = categoryComplete && languageComplete;
                              // &&
                              // (sitaComplete || referenceComplete);
                            }

                            if (index === 2) {
                              isComplete =
                                permissionsComplete &&
                                categoryComplete &&
                                languageComplete &&
                                (sitaComplete || referenceComplete) &&
                                activeStep === 2;
                            }

                            return (
                              <Step
                                key={label}
                                completed={isComplete}
                                sx={{
                                  padding: 0,
                                  "& .MuiStepIcon-root.Mui-completed": {
                                    color: "secondary.main",
                                  },
                                }}
                              >
                                <StepButton onClick={handleStep(index)}>
                                  <Typography
                                    variant="subtitle2"
                                    owner="admin"
                                    color="adminText.dark"
                                  >
                                    {label}
                                  </Typography>
                                </StepButton>
                              </Step>
                            );
                          })}
                        </Stepper>
                      </Col>
                    </Row>

                    <Row>
                      {activeStep === 0 && (
                        <>
                          <Col xs={12} className="mb-3">
                            <Typography
                              variant="body2"
                              owner="admin"
                              color="adminPrimary.main"
                              weight="medium"
                            >
                              Choose who can see your post
                            </Typography>
                          </Col>

                          <Col xs={12} sm={12} md={12} lg={12} xl={4}>
                            <div className="form-group mb-0">
                              <FormControlLabel
                                className="dark"
                                sx={{
                                  marginRight: "5px",
                                  marginBottom: 0,
                                  verticalAlign: "top",
                                }}
                                control={
                                  <Checkbox
                                    id="keep-private-checkbox"
                                    checked={keepPrivate}
                                    onChange={(event) => {
                                      setPrivate(!keepPrivate);
                                      setAdvancedPermissions(false);

                                      if (event.target.checked) {
                                        setPublic(false);
                                      }
                                    }}
                                  />
                                }
                                label={
                                  <Typography
                                    variant="subtitle2"
                                    owner="admin"
                                    color="adminText.main"
                                  >
                                    OPTION 1: Keep private
                                  </Typography>
                                }
                              />
                              <Tooltip
                                placement="top"
                                title="Selecting this option means the post will NOT be visible to standard users. Please note however that the post may still be visible to more senior users in a Manager or Editor role. Additionally, checking this option will not overwrite any other 'specific' access permissions (view, edit, delete) that may have been granted via option 3."
                              >
                                <InfoOutlined
                                  sx={{ marginTop: "-20px", fontSize: 16 }}
                                />
                              </Tooltip>
                            </div>
                          </Col>

                          <Col xs={12} sm={12} md={12} lg={12} xl={4}>
                            <div className="form-group mb-0">
                              <FormControlLabel
                                className="dark"
                                control={
                                  <Checkbox
                                    id="make-public-checkbox"
                                    checked={makePublic}
                                    onChange={(event) => {
                                      setPublic(!makePublic);
                                      setAdvancedPermissions(false);
                                      if (event.target.checked) {
                                        setPrivate(false);
                                      }
                                    }}
                                  />
                                }
                                label={
                                  <Typography
                                    variant="subtitle2"
                                    owner="admin"
                                    color="adminText.main"
                                  >
                                    OPTION 2: Set 'view' access for ALL
                                  </Typography>
                                }
                              />
                              <Tooltip
                                placement="top"
                                title="Selecting this option will give 'view' only access to all standard users. It will not overwrite any other 'specific' access permissions (view, edit, delete) that may have been granted via option 3."
                              >
                                <InfoOutlined
                                  sx={{ marginTop: "-20px", fontSize: 16 }}
                                />
                              </Tooltip>
                            </div>
                          </Col>

                          <Col xs={12} sm={12} md={12} lg={12} xl={4}>
                            <div className="form-group mb-0">
                              <FormControlLabel
                                className="dark"
                                sx={customPermsError ? { opacity: 0.5 } : {}}
                                control={
                                  <Checkbox
                                    id="advanced-checkbox"
                                    checked={advancedPermissions}
                                    disabled={customPermsError ? true : false}
                                    onChange={(event) => {
                                      setPublic(false);
                                      setPrivate(false);
                                      setAdvancedPermissions(
                                        event.target.checked,
                                      );
                                      setShareModalOpen(event.target.checked);
                                      setSharePostItem(activeGridItem);
                                      setHideShare(true);
                                    }}
                                  />
                                }
                                label={
                                  <Typography
                                    variant="subtitle2"
                                    owner="admin"
                                    color="adminText.main"
                                  >
                                    OPTION 3: Set specific user access
                                  </Typography>
                                }
                              />
                              <Tooltip
                                placement="top-start"
                                title="Selecting this option allows you to set 'specific' access permissions (view, edit, delete) for all users and roles."
                              >
                                <InfoOutlined
                                  sx={{ marginTop: "-20px", fontSize: 16 }}
                                />
                              </Tooltip>
                              {customPermsError && (
                                <Box sx={{ marginTop: 1 }}>
                                  <Alert
                                    variant="filled"
                                    severity="error"
                                    sx={{ fontSize: 12 }}
                                  >
                                    Due to an error, this option cannot be
                                    selected.
                                  </Alert>
                                </Box>
                              )}
                            </div>
                          </Col>
                        </>
                      )}

                      {activeStep === 1 && (
                        <>
                          <Col xs={12} className="mb-4">
                            <Typography
                              variant="body2"
                              owner="admin"
                              color="adminPrimary.main"
                              weight="medium"
                            >
                              Choose a category (*), language (*) and{" "}
                              {sitaEnabled ? "SITA code" : ""}{" "}
                              {referenceEnabled ? "reference" : ""} for your
                              post
                            </Typography>
                          </Col>
                          <Col xs={12} sm={6} md={4}>
                            <div className="form-group">
                              <FormControl
                                fullWidth
                                size="small"
                                sx={{ backgroundColor: "primary.light" }}
                              >
                                <InputLabel id={`category`}>
                                  Category *
                                </InputLabel>
                                <Select
                                  labelId={`category-id`}
                                  value={selectedCategory}
                                  open={open}
                                  onClose={() => setOpen(false)}
                                  onOpen={() => setOpen(true)}
                                  renderValue={(selected) => {
                                    const stringified = String(selected);

                                    if (!stringified || stringified === "0")
                                      return "All Categories";
                                    const found = categories.find(
                                      (c) => c.value === stringified,
                                    );

                                    return found
                                      ? decodeHtmlEntities(found.label)
                                      : "All Categories";
                                  }}
                                  input={
                                    <OutlinedInput
                                      sx={{
                                        fontSize: "16px",
                                        "&.MuiInput-underline:before": {
                                          borderBottomColor: "#d2d0cf",
                                        },
                                      }}
                                      label="Category"
                                    />
                                  }
                                >
                                  {allCategoryValues.map((id) => (
                                    <MenuItem
                                      key={`register-${id}`}
                                      value={id}
                                      sx={{ display: "none" }}
                                    />
                                  ))}

                                  <MenuItem
                                    key="all-categories"
                                    value={"0"}
                                    sx={{
                                      fontSize: "16px",
                                      fontWeight: "400",
                                      "&.Mui-selected": {
                                        backgroundColor: "primary.light",
                                      },
                                      display: "none",
                                    }}
                                    disabled
                                  >
                                    All Categories
                                  </MenuItem>

                                  {renderMenuItems(null)}
                                </Select>
                              </FormControl>
                              <Typography
                                variant="caption"
                                owner="admin"
                                color="adminText.main"
                              >
                                This field is <b>required</b>
                              </Typography>
                            </div>
                          </Col>
                          <Col xs={12} sm={6} md={4}>
                            <div className="form-group">
                              <FormControl
                                fullWidth
                                size="small"
                                sx={{ backgroundColor: "primary.light" }}
                              >
                                {/* SITA and Reference commented out */}
                                {sitaEnabled && (
                                  <Autocomplete
                                    options={sitas}
                                    getOptionLabel={(option) => option.title}
                                    value={selectedSita}
                                    disableClearable={true}
                                    onChange={(event, value) => {
                                      setSelectedSita(value);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="SITA"
                                        InputProps={{
                                          ...params.InputProps,
                                          type: "search",
                                          sx: {
                                            paddingBottom: 0,
                                            "& .MuiOutlinedInput-input": {
                                              paddingBottom: "0 !important",
                                              paddingTop: "0 !important",
                                              borderColor: "#c2ccd6",
                                            },
                                            "&:hover .MuiOutlinedInput-input": {
                                              borderWidth: "2px",
                                              borderColor: "primary.main",
                                            },
                                            "& .MuiAutocomplete-endAdornment": {
                                              top: "calc(50% - 16px)",
                                            },
                                          },
                                        }}
                                      />
                                    )}
                                  />
                                )}
                                {referenceEnabled && (
                                  <Autocomplete
                                    options={references}
                                    getOptionLabel={(option) => option.title}
                                    value={selectedReference}
                                    disableClearable={true}
                                    onChange={(event, value) => {
                                      setSelectedReference(value);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Reference"
                                        InputProps={{
                                          ...params.InputProps,
                                          type: "search",
                                          sx: {
                                            paddingBottom: 0,
                                            "& .MuiOutlinedInput-input": {
                                              paddingBottom: "0 !important",
                                              paddingTop: "0 !important",
                                              borderColor: "#c2ccd6",
                                            },
                                            "&:hover .MuiOutlinedInput-input": {
                                              borderWidth: "2px",
                                              borderColor: "primary.main",
                                            },
                                            // "& .MuiAutocomplete-endAdornment": {
                                            //   top: "calc(50% - 16px)",
                                            // },
                                          },
                                        }}
                                      />
                                    )}
                                  />
                                )}
                              </FormControl>
                              <Typography
                                variant="caption"
                                owner="admin"
                                color="adminText.main"
                              >
                                This field is <b>optional</b>
                              </Typography>
                            </div>
                          </Col>
                          <Col xs={12} sm={6} md={4}>
                            <div className="form-group">
                              <FormControl
                                fullWidth
                                size="small"
                                sx={{ backgroundColor: "primary.light" }}
                              >
                                <InputLabel id="language-select-label">
                                  Language *
                                </InputLabel>
                                <Select
                                  labelId="language-select-label"
                                  id="language-select"
                                  value={selectedLanguage}
                                  onChange={(event) => {
                                    setSelectedLanguage(
                                      parseInt(event.target.value),
                                    );
                                  }}
                                  input={
                                    <OutlinedInput
                                      sx={{
                                        fontSize: "16px",
                                        "&.MuiInput-underline:before": {
                                          borderBottomColor: "#d2d0cf",
                                        },
                                      }}
                                      label="Language"
                                    />
                                  }
                                >
                                  {languages?.map((language, index) => (
                                    <MenuItem
                                      key={`language-${index}`}
                                      value={language.value}
                                      sx={{ fontSize: "16px" }}
                                    >
                                      {language.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                              <Typography
                                variant="caption"
                                owner="admin"
                                color="adminText.main"
                              >
                                This field is <b>required</b>
                              </Typography>
                            </div>
                          </Col>
                        </>
                      )}

                      {activeStep === 2 && (
                        <>
                          {completed ? (
                            <>
                              <Col xs={12} className="mt-3">
                                <Typography
                                  variant="body2"
                                  owner="admin"
                                  color="adminText.main"
                                >
                                  All steps are completed. The post is now ready
                                  to be published.
                                </Typography>
                              </Col>
                            </>
                          ) : (
                            <>
                              <Col xs={12} className="mt-3">
                                <Typography>
                                  Please complete all steps. You cannot publish
                                  a post before completing all steps.
                                </Typography>
                              </Col>
                            </>
                          )}
                        </>
                      )}
                    </Row>

                    <Row className="mt-5 mb-5">
                      <Col xs={12} className="d-flex justify-content-center">
                        {activeStep !== 0 && (
                          <Button
                            variant="outlined"
                            owner="admin"
                            dialogbtn="true"
                            dialogvariant="cancel"
                            onClick={() => {
                              setActiveStep(activeStep - 1);
                            }}
                          >
                            <Typography
                              variant="button"
                              owner="admin"
                              className="lh"
                            >
                              Back
                            </Typography>
                          </Button>
                        )}
                        {activeStep !== 2 && (
                          <>
                            {activeStep === 0 && (
                              <Button
                                variant="contained"
                                owner="admin"
                                dialogbtn="true"
                                dialogvariant="primary"
                                className="lh"
                                onClick={() => {
                                  setActiveStep(activeStep + 1);
                                }}
                                disabled={permissionsComplete ? false : true}
                              >
                                <Typography
                                  variant="button"
                                  owner="admin"
                                  className="lh"
                                >
                                  Next
                                </Typography>
                              </Button>
                            )}

                            {activeStep === 1 && (
                              <Button
                                variant="contained"
                                owner="admin"
                                dialogbtn="true"
                                dialogvariant="primary"
                                onClick={() => {
                                  setActiveStep(activeStep + 1);
                                }}
                                disabled={
                                  categoryComplete &&
                                  languageComplete &&
                                  sitaComplete
                                    ? false
                                    : true
                                }
                              >
                                <Typography
                                  variant="button"
                                  owner="admin"
                                  className="lh"
                                >
                                  Next
                                </Typography>
                              </Button>
                            )}
                          </>
                        )}
                        {activeStep === 2 && (
                          <Button
                            variant="contained"
                            owner="admin"
                            dialogbtn="true"
                            dialogvariant="save"
                            className="lh"
                            disabled={
                              completed && activeStep === 2 ? false : true
                            }
                            onClick={() => {
                              // save
                              onPublish();
                            }}
                          >
                            <Typography
                              variant="button"
                              owner="admin"
                              className="lh"
                            >
                              Publish
                            </Typography>
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </>
                )}
              </Container>
            </Box>
          </DialogContent>
        </Dialog>
      )}
      {showUnpublish && activeGridItem && (
        <AlertModal
          showAlert={showUnpublish}
          showCaLogo={true}
          alertType={"warning"}
          alertMessageTitle={"Unpublish?"}
          alertMessageBody={
            "Any shared links will stop working. Are you sure you want to unpublish this post?"
          }
          cancelButton={true}
          cancelButtonLabel={"Cancel"}
          confirmButton={true}
          confirmButtonLabel={"Unpublish"}
          confirmButtonColor={"primary"}
          onConfirm={() => {
            unpublishPost();
          }}
          showAlertCallback={() => {
            setShowUnpublish(false);
          }}
        />
      )}
    </>
  );
}
